import { EventEmitter, Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ROLE, ROLEVALUES } from '../enum/roles.enum';
import { CalendarService } from './calendar.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  public isBadge = false;
  // currentCalendarYearId: number;
  hideTutorials = new EventEmitter<boolean>();
  setSelectedSchoolsToLocalStorage = new EventEmitter<boolean>();

  setSelectedSchoolsCalendarToLocalStorage = new EventEmitter<any>();  // Emits event when the academic year (school calendar) is changed
  submitAssitantQuestion = new EventEmitter<string>();
  updateLocalStoragUser = new EventEmitter<boolean>();
  isDialogComponentOpen = new EventEmitter<boolean>();

  public isSidebarClose: boolean = this.detectMob() ? true : false;
  public teacherRoles = [3, 8, 9, 10];
  public adminRoles = [4, 11, 12, 13, 14, 15, 16, 17, 21];
  public studentRoles = [18];
  public teachersOnlyRole = [22];
  public parentRole = [20];
  public superAdminRole = [19];
  public staffRoles = [1, 2, 5, 6, 7];

  constructor(
    private httpService: HttpService,
    private calendarService: CalendarService,
    private deviceService: DeviceDetectorService,
  ) {}

  setItem(key: string, value) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string) {
    if (key === 'user') {
      const user = JSON.parse(localStorage.getItem(key));
      user ? (user['user'] = this.getDecodeUser(user?.user)) : null;
      return user;
    } else {
      return JSON.parse(localStorage.getItem(key));
    }
  }

  getDecodeUser(value) {
    return this.httpService.decodeLoginToken(value);
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  clearStorage() {
    localStorage.clear();
  }

  detectMob() {
    return this.deviceService.isMobile() || this.deviceService.isTablet();

    // TODO: We need to create the regular expression for iPad Pro series with touche enable.
    // const toMatch = [
    //   /Android/i,
    //   /iPhone/i,
    //   /iPad/i,
    //   /iPod/i,
    //   /BlackBerry/i,
    //   /Windows Phone/i,
    //   /iPad Air/i,
    //   /iPad Pro/i,
    // ];
    // return toMatch.some((toMatchItem) => {
    //   return navigator.userAgent.match(toMatchItem);
    // });
  }

  async getCurrentSchoolCalendarYear() {
    // try {
    const user = this.getItem('user');
    let params;
    if (user && user.user.role_id === 19) {
      const currentSelectedSchoolBySuperAdmin = await this.getItem('selectedSchoolByAdmin');
      params = {
        school_id: currentSelectedSchoolBySuperAdmin?.id,
      };
    } else {
      params = {
        school_id: user?.user?.school?.id,
      };
    }
    let response = await this.calendarService.schoolCalendarBySchoolId(params);
    response = response.filter((item: any) => !item.isArchive && item.isActivate);

    const currentCalendar = (await this.getItem('selectedSchoolCalendarByAdmin'))
      ? await this.getItem('selectedSchoolCalendarByAdmin')
      : response[0];
    const currentCalendarYearId = currentCalendar?.isFirst === true ? true : currentCalendar?.id;
    return currentCalendarYearId;
    // } catch (error) {
    //   throw error;
    // }
  }

  checkFadeOutContent() {
    const currentCalendar = this.getItem('selectedSchoolCalendarByAdmin');

    return currentCalendar?.end < new Date().getTime() ? true : false;
  }

  checkUserRole(id: any, role: string): boolean {
    let result: boolean;
    if (role === ROLE.ADMIN) {
      result = this.adminRoles.includes(id);
    } else if (role === ROLE.TEACHER) {
      result = this.teacherRoles.includes(id);
    } else if (role === ROLE.STUDENT) {
      result = this.studentRoles.includes(id);
    } else if (role === ROLE.TEACHER_ONLY) {
      result = this.teachersOnlyRole.includes(id);
    } else if (role === ROLE.PARENT) {
      result = this.parentRole.includes(id);
    } else if (role === ROLE.SUPER_ADMIN) {
      result = this.superAdminRole.includes(id);
    } else if (role === ROLE.STAFF) {
      result = this.staffRoles.includes(id);
    }
    return result;
  }

  checkIsTeacherOnlyUser(): boolean {
    const user = this.getItem('user');
    if (user.role_id === ROLEVALUES.TEACHER_ONLY) return true;
    else return false;
  }
}
